module.exports = __webpack_public_path__ + "static/media/icon-planilhas.dea2d767.svg";